// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"cfe4de6c","620":"68e8955b"}[chunkId] + ".chunk.js";
};